<template>
  <div class="row">
  
      <div class="col-md-5 event_detail_ls">
          <div class="event_detail_wrapper">
              <div class="row">
  
                  <div class="event_ls_label col-md-2">Exhibtion Area Name</div>
                  <div class="col-md-8">{{item.name}}</div>
              </div>
          </div>
          <div class="event_detail_wrapper">
              <div class="row">
                  <div class="event_ls_label col-md-2">Exhibtion Area Type</div>
                  <div class="col-md-8">{{ (item.type) }}</div>
              </div>
          </div>
          
      </div>
      
      <div class="text-right mt-3 mr-5">
          <button  type="button" class="mb-1 mt-1 me-1 btn btn-lg btn-primary" @click="editData(item)">Edit</button>
          <button  type="button" class="mb-1 mt-1 me-1 btn btn-lg btn-danger" @click="deleteData(item)">Delete</button>
      </div>
  </div>
  </template>
  
  <script>
  import {
      mapGetters,
      mapActions
  } from 'vuex'
  import constants from "@/config/constants";
  import { isPermits} from "@/services/CheckPermissions";
  import _ from "lodash";
  
  export default {
      name: "ShowItem",
      data() {
          
      },
      props: {
          checkPermssions:null,
          item: {
              type: Object,
              default () {
                  return {
                      name: null,
                      email: null,
                      company: null,
                      role: null,
                  }
              }
          },
          event:null,
          id: {
              type: String
          },
          
      },
      created() {
      },
      computed: {
          ...mapGetters("AuthenticationsIndex",{checkPermssions:"all", role:"role",isCan:"isCan"}),
      },
      methods: {
          ...mapActions("AuthenticationsIndex",   ["fetchPermissions","fetchPermissionsOnLoad"]),
          ...mapActions('ExhibitionAreasIndex',   ['fetchData', 'destroyData']),
          ...mapActions('ExhibitionAreasSingle',  ['setItem', 'setIsNew', 'setIsEditing']),
          deleteData(item) {
              this.$swal({
                  title: "Are you sure?",
                  text: "You won't be able to revert this!",
                  type: "warning",
                  showCancelButton: true,
                  confirmButtonText: "Delete",
                  confirmButtonColor: "#dd4b39",
                  focusCancel: true,
                  reverseButtons: true
              }).then(result => {
                  if (result.isConfirmed) {
                      this.destroyData(item._id).then(() => {
                          this.$flashMessage.show({
                          group   : 'event_exhibition_area_index',
                          type    : 'success',
                          title   : 'Success',
                          time    : 1000,
                          html    : '<ul><li>Exhibition Area has been deleted successfully.</li></ul>'
                        });
                          this.fetchData(this.$route.params.event_id);
                          this.setIsNew(false);
                          this.setIsEditing(false);
                      })
                  }
              });
          },
          editData(item) {
              console.log("Item here",item);
              this.setItem(item);
              this.setIsNew(false);
              this.setIsEditing(true);
              this.$forceUpdate();
          },
          
          can(permit,permissions){
              return isPermits(permit,permissions);
          }
      },
  
  }
  </script>
  
  <style lang="scss" scoped>
  .user_img {
      img {
          width: 100%;
      }
  }
  
  .event_detail_wrapper {
      padding: 10px 0px;
  
      .event_ls_label {
          font-weight: bold;
      }
  
      .row {
          .col-md-8 {
              border-bottom: 1px dotted #ccc;
              padding-bottom: 5px;
          }
  
          .col-md-3 {
              border-bottom: 1px dotted #ccc;
              padding-bottom: 5px;
          }
      }
  
      .card-body {
          box-shadow: 0px 0px #ffffff;
      }
  }
  
  .tabs-vertical {
      border-top: 0px;
  }
  
  .toggle-content{
    background:#fff;
  }
  </style>
  